var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vertical-flex-fit overflow-y-auto" },
    [
      _c(
        "b-card",
        { staticClass: "financial-tools-card" },
        [
          _c("h6", { staticClass: "bold ml-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("financial-tools.mortgageCalculators")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _vm.CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES === true
            ? _c("div", { attrs: { id: "financial-tools-section" } }, [
                _c(
                  "div",
                  { staticClass: "ml-3" },
                  [
                    _c("financial-tools", {
                      attrs: { "client-username": _vm.clientUsername },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES === false
            ? _c(
                "b-row",
                {
                  staticClass: "align-items-center justify-content-center pb-3",
                },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "no-results",
                        {
                          attrs: {
                            "img-src": require("@Shared/@Assets/img/application-missing.png"),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "global.messages.youNeedToFillOutMortgageDetailsFirst"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasReferralPartners
        ? _c(
            "div",
            { attrs: { id: "services-tab" } },
            [
              _c("b-card", [
                _c("div", { staticClass: "services-tab py-3" }, [
                  _c("div", [
                    _c("h6", { staticClass: "bold ml-3" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm
                              .$t("application-form.personalInsuranceProvider")
                              .toString()
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row justify-content-between mb-3 ml-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-sm col-md-4 form-container" },
                          [
                            _c(
                              "span",
                              { staticClass: "form-title font mb-0" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm
                                        .$t("application-form.provider")
                                        .toString()
                                    ) +
                                    "\n                "
                                ),
                                _c("input-required-indicator"),
                                _vm._v(" "),
                                _vm.loadingProviders
                                  ? _c("inline-loader", {
                                      staticClass: "mx-2",
                                      attrs: { width: "12px", height: "12px" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "material-input",
                              {
                                staticClass: "w-75 pb-3",
                                attrs: { "no-label": "" },
                              },
                              [
                                _c("v-select-field", {
                                  key:
                                    "provider-select-" +
                                    (_vm.providerNameOptions.length || 0) +
                                    "-" +
                                    (_vm.providerDropdownValue || ""),
                                  staticClass: "simple-dd",
                                  attrs: {
                                    options: _vm.providerNameOptions,
                                    "default-value": _vm.providerDropdownValue,
                                    scenario: "simple",
                                    clearable: false,
                                    placeholder: _vm
                                      .$t("application-form.provider")
                                      .toString(),
                                  },
                                  on: {
                                    "option:selected": _vm.selectProviderName,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm col-md-4 form-container" },
                          [
                            _c(
                              "h6",
                              { staticClass: "form-title font-sm mb-0" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm
                                        .$t("response-information.product")
                                        .toString()
                                    ) +
                                    "\n                "
                                ),
                                _c("input-required-indicator"),
                                _vm._v(" "),
                                _vm.loadingProviders
                                  ? _c("inline-loader", {
                                      staticClass: "mx-2",
                                      attrs: { width: "12px", height: "12px" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "material-input",
                              {
                                staticClass: "w-75 pb-3",
                                attrs: { "no-label": "" },
                              },
                              [
                                _c("v-select-field", {
                                  key:
                                    "product-select-" +
                                    (_vm.productNameOptions.length || 0) +
                                    "-" +
                                    (_vm.productDropdownValue || ""),
                                  staticClass: "simple-dd",
                                  attrs: {
                                    id: "productNameDropdown",
                                    options: _vm.productNameOptions,
                                    "default-value": _vm.productDropdownValue,
                                    clearable: false,
                                    placeholder: _vm
                                      .$t("response-information.product")
                                      .toString(),
                                  },
                                  on: {
                                    "option:selected": _vm.selectProductName,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "logo mb-3" }, [
                          _vm.providerDropdownValue
                            ? _c("img", {
                                staticClass: "logo-img",
                                attrs: {
                                  src: require("@Shared/@Assets/img/insurance-product-logo/" +
                                    _vm.providerDropdownValue +
                                    ".png"),
                                  alt: "insurance-product-logo",
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("h6", { staticClass: "bold ml-3" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("application-form.applicantsToBeInsured")
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex flex-row ml-3 mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column" },
                        _vm._l(_vm.allApplicants, function (applicant, index) {
                          return _c("div", { key: applicant.username }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pretty p-icon p-jelly p-smooth p-curve mr-2",
                              },
                              [
                                _c("input", {
                                  staticClass: "checkbox",
                                  attrs: {
                                    id: "applicant-" + index,
                                    disabled: index === 0,
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked:
                                      index === 0
                                        ? true
                                        : _vm.applicantsChecked[index]
                                            .isChecked,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.applicantsChecked[index].isChecked =
                                        !_vm.applicantsChecked[index].isChecked
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "state p-success",
                                    style: { opacity: 1 },
                                  },
                                  [
                                    _c("icon", {
                                      staticClass: "icon",
                                      attrs: { name: "check" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { attrs: { for: "applicant-" + index } },
                                      [_vm._v(_vm._s(applicant.fullName))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column" },
                        _vm._l(_vm.allApplicants, function (applicant) {
                          return _c("div", { key: applicant.username }, [
                            _c("span", [
                              _vm._v(_vm._s(applicant.applicantType)),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ml-3" },
                      [
                        _c("p", { staticClass: "mb-2" }, [
                          _vm._v(
                            _vm._s(_vm.$t("application-form.insuranceNote"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-jelly p-smooth p-curve mr-2",
                          },
                          [
                            _c("input", {
                              staticClass: "checkbox",
                              attrs: { id: "applicant-", type: "checkbox" },
                              domProps: { checked: _vm.consentChecked },
                              on: {
                                click: function ($event) {
                                  _vm.consentChecked = !_vm.consentChecked
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "state p-success" },
                              [
                                _c("icon", {
                                  staticClass: "icon",
                                  attrs: { name: "check" },
                                }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "applicant" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-form.insuranceConsent"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("simple-button", {
                          attrs: {
                            "class-name": "btn-sm mr-2 btn-primary",
                            type: "white",
                            disabled:
                              !_vm.consentChecked ||
                              _vm.productDropdownValue === "" ||
                              _vm.productDropdownValue === null ||
                              _vm.providerDropdownValue === "",
                            loading: _vm.sendSubmissionBtnLoading,
                            text: _vm
                              .$t("application-form.submitRequest")
                              .toString(),
                          },
                          on: { click: _vm.handleSubmitRequest },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.errorMsg.length != 0
                      ? _c(
                          "h6",
                          { staticClass: "bold ml-3 mt-4 text-danger" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm
                                    .$t("application-form.submitRequestError")
                                    .toString()
                                ) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMsg.length != 0
                      ? _c("div", [
                          _c(
                            "ul",
                            _vm._l(_vm.errorMsg, function (error, index) {
                              return _c("li", { key: index }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(error) +
                                    "\n              "
                                ),
                              ])
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("b-card", { attrs: { id: "insurance-submissions-history" } }, [
                _c(
                  "div",
                  [
                    _c("h6", { staticClass: "bold ml-3 mt-2" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm
                              .$t("application-form.insuranceOrderSummary")
                              .toString()
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.loadingSubmissions &&
                    _vm.tableData &&
                    _vm.tableData.length > 0
                      ? _c("v-client-table", {
                          ref: "servicesTable",
                          staticClass:
                            "table-clients no-pagination vue-custom-table mb-0",
                          attrs: {
                            columns: _vm.tableOptions.columns,
                            options: _vm.tableOptions,
                            data: _vm.tableData,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "statusDateTime",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatDateHour(
                                              row.statusDateTime
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "name",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "div",
                                      _vm._l(
                                        row.name,
                                        function (applicant, index) {
                                          return _c("div", { key: index }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(applicant) +
                                                "\n              "
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3241571282
                          ),
                        })
                      : _vm.loadingSubmissions
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-center py-4" },
                          [_c("report-history-table-row-loader")],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }